import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export const StepSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center space-y-8 max-w-lg">
        {/* Success Icon */}
        <div className="relative inline-block">
          <div className="absolute inset-0 bg-primary/20 rounded-full blur-3xl animate-pulse-soft" />
          <div className="relative bg-gradient-to-br from-primary/20 to-primary/5 p-12 rounded-full">
            <Sparkles className="h-32 w-32 text-primary" />
          </div>
        </div>

        {/* Success Message */}
        <div className="space-y-4">
          <h1 className="text-4xl font-bold">You're All Set! 🎉</h1>
          <p className="text-lg text-muted-foreground">
            Sophie AI is configuring your business information. It won't take long.
          </p>
          <p className="text-muted-foreground">
            We'll take you to your dashboard automatically when she's ready.
          </p>
        </div>

        {/* Manual Button */}
        <Button
          onClick={() => navigate("/")}
          size="lg"
          className="gap-2"
        >
          Go to Dashboard Now
          <Sparkles className="h-4 w-4" />
        </Button>

        {/* Auto-redirect notice */}
        <p className="text-sm text-muted-foreground">
          Redirecting automatically in a few seconds...
        </p>
      </div>
    </div>
  );
};
